module.exports = __webpack_public_path__ + "img/a0.37dd4147.jpg";